import React from "react";
import { PropTypes } from 'prop-types';
import {
  PopContainer,
  PopupHeading,
  PopupContentLine1,
  PopupContentContainer,
  PrimaryButton,
  DisplayFlexCenter,
  Underlinelink,
  PopContainerWrap,
  PopupWrap,
  PopupContentLine1Align,
  IconWrap
} from "./styles";
import { Cross } from "../ExpandClose";

class Popup extends React.Component {
  componentDidMount() {
    document.body.style.overflow = "hidden";
  }

  componentWillUnmount() {
    document.body.style.overflow = "";
  }
  render() {
    return (
      <PopContainerWrap>
        <PopupWrap mheight={this.props.mheight} mwidth={this.props.mwidth} height={this.props.height} width={this.props.width}>
          <PopContainer>
            <IconWrap onClick={this.props.closeModal} id="legacyAccordionPopupCrossWrapper">
              <Cross />
            </IconWrap>
            <PopupHeading dangerouslySetInnerHTML={{__html:this.props.content.heading}} />
            <PopupContentContainer>
              {this.props.content.type == "reset" ? (
                <DisplayFlexCenter>
                  <PopupContentLine1>
                    <span dangerouslySetInnerHTML={{__html:this.props.content.line1}} />
                  </PopupContentLine1>
                </DisplayFlexCenter>
              ) : this.props.content.type == "exit" ? (
                <DisplayFlexCenter>
                  <PopupContentLine1Align width="88%" paddingBottom="30px">
                   <span dangerouslySetInnerHTML={{__html:this.props.content.line1}} />
                  </PopupContentLine1Align>
                </DisplayFlexCenter>
              ) : this.props.content.type == "removeInfo" ? (
                <DisplayFlexCenter>
                  <PopupContentLine1Align width="88%" paddingBottom="30px">
                    <span dangerouslySetInnerHTML={{__html:this.props.content.line1}} />
                  </PopupContentLine1Align>
                </DisplayFlexCenter>
              ) :
              this.props.content.type == "remove" ? (
                <DisplayFlexCenter>
                  <PopupContentLine1Align width="309px" paddingBottom="30px">
                    <span dangerouslySetInnerHTML={{__html:this.props.content.line1}} />
                  </PopupContentLine1Align>
                </DisplayFlexCenter>
              ) : (
                <DisplayFlexCenter>
                  <PopupContentLine1Align width="485px !important" paddingBottom="10px">
                    <span dangerouslySetInnerHTML={{__html:this.props.content.line1}} />
                  </PopupContentLine1Align>
                </DisplayFlexCenter>
              )}
              {/* Might Need Line Two To Display after Discussion */}
              {/* <div>{this.props.content.line2 != '' && this.props.content.line2}</div> */}
            </PopupContentContainer>

            <DisplayFlexCenter>
              {
                this.props.content.type == "autofill" ? 
                <PrimaryButton onClick={this.props.handleContinue} id="btnContinue">{this.props.content.continue}</PrimaryButton> :
                this.props.content.type == "reset" ? (
                  this.props.advisorType == "Primary"  || this.props.advisorType == "legacy"  ? (
                    <PrimaryButton onClick={this.props.handleReset} id="btnReset">{this.props.content.continue}</PrimaryButton>
                  ) : (
                    <PrimaryButton onClick={this.props.handleResetSecondary} id="btnResetSec">{this.props.content.continue}</PrimaryButton>
                  )
                ) : this.props.content.type == "exit" ? (
                  <PrimaryButton onClick={this.props.handleExitClick} id="btnExit">{this.props.content.continue}</PrimaryButton>
                ) : (
                  <PrimaryButton onClick={this.props.handleRemove} id="btnRemove">{this.props.content.continue}</PrimaryButton>
                )
              }
            </DisplayFlexCenter>
            <Underlinelink onClick={this.props.closeModal} dangerouslySetInnerHTML={{__html:this.props.content.cancel}} id="anrCancel"/>
          </PopContainer>
        </PopupWrap>
      </PopContainerWrap>
    );
  }
}

Popup.propTypes = {
  advisorType: PropTypes.any,
  closeModal: PropTypes.func,
  content: PropTypes.object,
  handleRemove: PropTypes.func,
  height: PropTypes.string,
  mheight: PropTypes.string,
  mwidth: PropTypes.string,
  width: PropTypes.string,
  handleReset: PropTypes.func,
  handleResetSecondary: PropTypes.func,
  handleExitClick: PropTypes.func,
}

export default Popup;
